<template>
  <base-dialog-full :show="true"
                    :tempSaveBtn="false"
                    title="簽名資料"
                    @close="closeSignDialog"
                    @save="saveSignDialog">
      <div>
        <policy-signature ref="Search_INS_S8"
                          :trans-code="transCode"
                          :change-yn="'N'"
                          :signed-yn="'N'"
                          :is-preview="false"
                          :parent-title="'簽名資料'"
                          :source-flag-to-go="sourceFlagToGo"
                          @set-change="setChange"
                          @destroy="signatureDestroyHandler"
                          @close="insS8TabCloseHandler"
                          @signed-handler="signedHandler"
                          @next-tab="nextStepHandler"
                          @pre-tab="preStepHandler">
        </policy-signature>
        <base-btn>
          <btn-lg-primary v-if="showNextStepBtn" @click="nextStepClick">下一步</btn-lg-primary>
          <btn-lg-primary v-if="showjumpAppBtn" @click="jumpAppClick">跳轉保險公司</btn-lg-primary>
        </base-btn>
        <btn-lg-primary v-if="showNextStepBtn" style="position: fixed;top: 360px;right: 30px;min-width: 126px;"
                @click="nextStepClick">下一步</btn-lg-primary>
        <btn-lg-primary v-if="showjumpAppBtn" style="position: fixed;top: 360px;right: 30px;min-width: 126px;"
                @click="jumpAppClick">跳轉保險公司</btn-lg-primary>
      </div>
  </base-dialog-full>
</template>
<script>
import PolicySignature from '@/components/Ins/Policy/PolicySignature.vue'
import store from '@/store'
import { withDebounce } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('ins')
const { mapActions: commonMapActions} = createNamespacedHelpers('common')
export default {
  components: { PolicySignature },
  data () {
    return {
      isFinishedSign: false,
      showNextStepBtn: false,
      showjumpAppBtn: false,
      policiesInfo: null, //保單資訊
    }
  },
  emits: ['close'],
  props: {
    value: {
      type: Boolean
    },
    transCode: {
      type: String,
      default: ''
    },
    sourceFlagToGo: {  //『進入來源』: O=要保書查詢頁「跳轉保險公司」按鈕進入 , S=要保書查詢頁「編輯」按鈕進入
      type: String,
      default: ''
    }
  },
  computed: {
  },
  mounted () {
    console.log('ProposalDialogSignature')
    const {transCode} = this
    const vm = this
    const reqPoliciesInfo = store.dispatch('ins/fetchInsPoliciesInfo', { transCode }) //保單資訊
    Promise.all([reqPoliciesInfo]).then(r => {
       const [ rPoliciesInfo ] = r
       vm.policiesInfo = rPoliciesInfo.data
    })
    if(this.sourceFlagToGo === 'O'){
      this.showjumpAppBtn = true //跳到 [保險公司 APP]
    }
  },
  methods: {
    ...mapActions([
      'fetchJumpApp'
    ]),
    ...commonMapActions(['postUserAccessLog']),
    $postUserAccessLog (params) {
      const { transCode } = this
      params.transCode = transCode
      return this.postUserAccessLog(params)
    },
    preStepHandler: withDebounce(function () {
    }),
    nextStepHandler () {
    },
    nextStepClick: withDebounce(function () {//下一步 按鈕點選觸發
      if(this.$refs['Search_INS_S8']){
        if(this.isFinishedSign){
          this.$refs['Search_INS_S8'].preViewStepHandler()
        }
        this.$postUserAccessLog({ progClassName: 'signature_next', methodName: '下一步', stepCode: 'INS_S8' })
        const {transCode,policiesInfo} = this
        const params = { notReloadAction: true,	enterpoint: 'proposal',compCode: policiesInfo.compCode,
              transCode,routerPage: 'INS_S9',
              propKey: {
                transCode
              },
              isPreview: false, polInsureType: policiesInfo.polInsureType
            }
        this.$router.replace({ name: 'proposalMain', params }).catch(err => {}) //跳轉回建議書
      }
    }),
    jumpAppClick: withDebounce(function () {//跳轉保險公司 按鈕點選觸發
      //fix: Issue #83809, Issue #83807 , 調整為 跳轉保險公司
      const {policiesInfo} = this
      if(!policiesInfo) return
      const vm = this
      if(this.$refs['Search_INS_S8']){
        const actionFlow = ()=>{
          vm.insStepHandler({ progClassName: 'proposal_jumpApp', methodName: '要保書轉跳APP', stepCode: '', transCode: policiesInfo.transCode, polInsureType: policiesInfo.polInsureType})
          vm.fetchJumpApp({
            transCode: policiesInfo.transCode,
            compCode: policiesInfo.compCode,
            insAcceptDt: policiesInfo.insAcceptDt, // Timestamp 傳去後端轉String處裡
            insAcceptNo: policiesInfo.insAcceptNo
          }).then(r => {
            const { erorrMsg,url } = r.data
            if ( erorrMsg != null) { // 進入時間是否超過12小時或已跨日，顯示錯誤訊息
              vm.$alert(erorrMsg)
            } else {
              // window.location.replace(url)
              window.open(url, '_blank') // 跳轉凱壽APP
              //vm.$router.replace({ name: 'proposal' }) //無法用此路徑，因為目前已是
              vm.$emit('close')
            }
          })
        }
        if(this.isFinishedSign){
          this.$refs['Search_INS_S8'].preViewStepHandler()
          actionFlow()
        }else{
          //fix: Issue #83807 , 『合計應簽名數量』<>『合計已簽名數量』時，額外顯示訊息
          vm.$alert('保戶尚未於書面分析及個資同意書簽名，若您為訪客前先協助客戶至保險公司頁面或APP預填，可暫忽略本訊息，但記得正式面訪客戶時務必請客戶於 iPAD先簽「個資同意書及書面分析」２文件，以免投保後需再次回頭請客戶簽署。」').then(actionFlow)
        }
      }
    }),
    saveHandler () {
    },
    setChange () {
    },
    signatureDestroyHandler () {
      // this.$emit('destory', true)
      // const $htmlScroll = document.documentElement // 關閉 html scrollbar
      // $htmlScroll.className = ''
      // setTimeout(() => {
      //   window.location.reload()
      // }, 0)
    },
    signedHandler (val) {
      // 客戶全部簽名完成後觸發狀態旗標
      if (val === 'Finished') {
        this.isFinishedSign = true
        if(this.sourceFlagToGo === 'S'){
          this.showNextStepBtn = true //下一步
        }
      }else{
        this.isFinishedSign = false
        this.showNextStepBtn = false
      }
    },
    insS8TabCloseHandler () {
    },
    closeSignDialog(){
      this.$confirm('是否確認離開此要簽名流程？').then(yn => {
        if (yn) {
          this.$emit('close')
          // const progClassName = `QuitInsS${this.tabStep}`
          // this.$postUserAccessLog({ progClassName, methodName: '退出', stepCode: this.tabStep, transCode: this.transCode })
        }
      })

    },
    insStepHandler ({ progClassName, methodName, stepCode }) {
      // save access log
      store.dispatch('common/postUserAccessLog', {
          transCode: this.transCode,
          actionMsg: '',
          progClassName: progClassName,
          methodName: methodName,
          sysType: 'F',
          stepCode: stepCode
        })
        .then(r => {})
    },
    saveSignDialog(){},
  },
  watch: {
  },
}
</script>
<style lang="stylus" scoped>
</style>
